import script from "./ReportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportButton.vue?vue&type=script&setup=true&lang=js"

import "./ReportButton.vue?vue&type=style&index=0&id=578a28d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578a28d8"]])

export default __exports__